var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5271 34.0587L31.6601 23.5126C29.7448 22.2396 27.2012 23.6327 27.2012 25.9546L27.2012 47.0469C27.2012 49.3689 29.7448 50.7619 31.6601 49.4889L47.5271 38.9428C49.2618 37.7898 49.2618 35.2117 47.5271 34.0587Z",
    fill: "#36434E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 67.16C52.7011 67.16 66.24 53.4331 66.24 36.5C66.24 19.567 52.7011 5.84 36 5.84C19.2989 5.84 5.76 19.567 5.76 36.5C5.76 53.4331 19.2989 67.16 36 67.16ZM36 73C55.8823 73 72 56.6584 72 36.5C72 16.3416 55.8823 0 36 0C16.1178 0 0 16.3416 0 36.5C0 56.6584 16.1178 73 36 73Z",
    fill: "#36434E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoIcon);
export default __webpack_public_path__ + "static/media/play-video-icon.bc5cea268580bcb40a5ad7fef1983891.svg";
export { ForwardRef as ReactComponent };